import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { buildMatchLink, type MatchParams } from '../../utils/matchParams';
interface ArticleCTABandProps {
  body: string;
  buttonLabel: string;
  /** Compact variant sits inside the article body; full sits at the end. */
  variant?: 'inline' | 'full';
  /** Pre-populates the match widget with this article's context. */
  match?: MatchParams;
}
export function ArticleCTABand({
  body,
  buttonLabel,
  variant = 'full',
  match
}: ArticleCTABandProps) {
  const to = buildMatchLink('/request-information', match);
  if (variant === 'inline') {
    return <aside className="bg-light border border-gray-200 rounded-xl p-6 sm:p-7" data-id="element-109" data-mp="tiscq2lghkop">
        <p className="text-gray-700 leading-relaxed mb-5" data-id="element-110" data-mp="okqxjsr5i5ii">{body}</p>
        <Link to={to} className="inline-flex items-center justify-center gap-2 h-11 px-6 bg-primary hover:bg-primary-hover active:bg-secondary text-white font-semibold text-[15px] leading-none rounded-full shadow-ds transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" data-id="element-111" data-mp="kicf39re97rr">
          {buttonLabel}
          <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-112" data-mp="1mb7kckoo36qs" />
        </Link>
        <p className="mt-3 text-xs text-gray-500" data-id="element-113" data-mp="1qaztayhz3ewo">
          Free for students. No obligation to enroll.
        </p>
      </aside>;
  }
  return <section className="bg-navy py-14" data-id="element-114" data-mp="2dz9afn48rehh">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-115" data-mp="2j0ynt9exs48q">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-116" data-mp="250nve1xzahlg">
          Get Matched Free
        </h2>
        <p className="text-white/80 leading-relaxed mb-8" data-id="element-117" data-mp="29zqp4q8id1e4">{body}</p>
        <Link to={to} className="inline-flex items-center justify-center gap-2 h-[52px] px-8 bg-primary hover:bg-primary-hover active:bg-secondary text-white font-semibold text-base leading-none rounded-full shadow-ds-md transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" data-id="element-118" data-mp="29xxgx6i8y940">
          {buttonLabel}
          <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-119" data-mp="2vd0qmudgnouk" />
        </Link>
        <p className="mt-4 text-xs text-white/60" data-id="element-120" data-mp="2qi4zrxjyn7j1">
          Matching is free for students. No obligation to enroll.
        </p>
      </div>
    </section>;
}